@for (incidentCase of arrIncidents; track $index) {

<div
  class="p-5 mt-5 mb-3 bg-red-4 font-roboto-500 text-16 rounded-5 text-grey-1 max-sm:text-13 max-sm:p-3 max-sm:mt-2"
>
  <div class="animate-pulse bg-[#DDDEE0] w-[50px] h-[20px]"></div>
</div>

<div class="flex flex-col gap-5">
  @for (incident of arrItemByIncidents; track $index; let isPar = $even ) {
  <div class="flex items-center gap-2" [class.flex-row-reverse]="isPar">
    <div class="animate-pulse bg-[#DDDEE0] max-w-[30px] w-full text-16"></div>
    <div class="animate-pulse w-5 h-5 bg-[#DDDEE0] rounded-full"></div>

    <div
      nz-col
      class="gap-2 text-incident max-sm:gap-1"
      [class.inline-flex]="isPar"
      [class.grid]="!isPar"
      [class.text-left]="!isPar"
      [class.text-right]="false"
      [class.justify-start]="!isPar"
      [class.justify-end]="false"
    >
      <div class="animate-pulse bg-[#DDDEE0] w-[50px] h-[20px]"></div>
      <div class="animate-pulse bg-[#DDDEE0] w-[50px] h-[20px]"></div>
    </div>
  </div>
  }
</div>
}
